// extracted by mini-css-extract-plugin
export var active = "_c4-c";
export var compactArrow = "_c4-5";
export var container = "_c4-0";
export var dot = "_c4-b";
export var dotContainer = "_c4-a";
export var hoverArrowButton = "_c4-7";
export var hoverArrowContainer = "_c4-6";
export var leftHoverArrowContainer = "_c4-8 _c4-6";
export var rightHoverArrowContainer = "_c4-9 _c4-6";
export var slide = "_c4-4";
export var sliderContainer = "_c4-1";
export var sliderContainerVisibleOverflow = "_c4-2";
export var sliderOverflow = "_c4-3";
export var vignetteBoth = "_c4-f";
export var vignetteLeft = "_c4-e";
export var vignetteRight = "_c4-d";